import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {PedidoLoja} from "../../objeto/PedidoLoja";
import {DadosCartao} from "../../objeto/DadosCartao";
import {ICartaoCreditoGateway} from "../../objeto/ICartaoCreditoGateway";
import {IFormCartaoRespostaValido} from "../../objeto/IFormCartaoRespostaValido";
import {NgForm} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {CadCartaoPadrao} from "../../objeto/CadCartaoPadrao";
import {AutorizacaoLojaService} from "../../services/autorizacao-loja.service";
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-cad-cartao-getnet',
  templateUrl: './cad-cartao-getnet.component.html',
  styleUrls: ['./cad-cartao-getnet.component.scss']
})
export class CadCartaoGetnetComponent implements OnInit, ICartaoCreditoGateway {
  @ViewChild('frm', { static: false}) frm: NgForm;
  @ViewChild('frm', { read: ElementRef }) public frmElement: ElementRef;
  @ViewChild('containerDesafio3ds', { static: false}) containerDesafio3ds: ElementRef<HTMLDivElement>;
  @Input() pedido: PedidoLoja;
  @Input() formaDePagamento: any;

  cartao: DadosCartao = new DadosCartao();
  tiposCartao = [
    {id: 'CREDIT', descricao: 'Crédito'},
    {id: 'DEBIT', descricao: 'Débito'}
  ];
  mensagemErro: string;
  carregando = false;
  mensagemCarregamento = 'Validando cartao com seguranca';
  desafio3dsAberto = false;
  desafio3dsCarregando = false;
  private timeoutDesafio3ds: any;
  private listenerDesafio3ds: any;
  private resolveDesafio3ds: (token: string) => void;
  private rejectDesafio3ds: (erro: any) => void;

  constructor(private http: HttpClient,
              private cadCartaoPadrao: CadCartaoPadrao,
              private autorizacaoService: AutorizacaoLojaService,
              private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.cartao.tipoDoCartao = this.tiposCartao[0];
    this.preenchaDadosCliente();
  }

  ehValido(): IFormCartaoRespostaValido {
    return this.cadCartaoPadrao.ehValido(this.frm, this.frmElement);
  }

  async crieTokenCartao(enderecoCobranca: any): Promise<DadosCartao> {
    try{
      this.inicieCarregamento('Tokenizando cartao com seguranca');
      delete this.mensagemErro;
      await this.prepareAntifraudeGetnet();

      const tokenizacao3ds: any = await this.tokenizeCartao();
      this.apliqueRetornoTokenizacao(tokenizacao3ds);

      const autenticacao3ds = await this.autentique3ds(enderecoCobranca);
      this.apliqueRetornoAutenticacao3ds(autenticacao3ds);
      this.cartao.tipoDoCartao = this.cartao.tipoDoCartao?.id || this.cartao.tipoDoCartao || 'CREDIT';

      this.inicieCarregamento('Gerando token final do cartao');
      const tokenizacaoPagamento: any = await this.tokenizeCartao();
      this.apliqueRetornoTokenizacao(tokenizacaoPagamento);

      return this.cartao;
    } catch(erro: any) {
      this.mensagemErro = this.obtenhaMensagemErro(erro);
      throw this.mensagemErro;
    } finally {
      this.finalizeCarregamento();
    }
  }

  exibaCartao(dadosCartao: DadosCartao) {
    this.cartao = new DadosCartao();

    if(dadosCartao)
      Object.assign(this.cartao, dadosCartao);

    const tipoId = this.cartao.tipoDoCartao?.id || this.cartao.tipoDoCartao;
    const tipo = this.tiposCartao.find((item) => item.id === tipoId);
    this.cartao.tipoDoCartao = tipo || this.tiposCartao[0];
    this.preenchaDadosCliente();
  }

  fecheMensagemErro(){
    delete this.mensagemErro;
  }

  private preenchaDadosCliente(){
    let usuario: any = this.autorizacaoService.getUsuario();
    if(!usuario) usuario = this.pedido?.contato;

    if(usuario && usuario.cpf && !this.cartao.cpf)
      this.cartao.cpf = usuario.cpf;

    if(usuario && usuario.email && !this.cartao.email)
      this.cartao.email = usuario.email;
  }

  private async tokenizeCartao(): Promise<any> {
    const payload = {
      formaDePagamentoId: this.formaDePagamento?.id,
      card_number: this.somenteNumeros(this.cartao.numero),
      customer_id: this.somenteNumeros(this.cartao.cpf)
    };

    const resposta: any = await this.http.post('/getnet/cartao/tokenize', payload).toPromise();
    return this.extraiaDataResposta(resposta);
  }

  private apliqueRetornoTokenizacao(tokenizacao: any): void {
    const token = tokenizacao?.number_token || tokenizacao?.token;
    if(!token)
      throw Error('Tokenização Getnet não retornou number_token');

    this.cartao.token = token;
    this.cartao.bandeira = tokenizacao.brand || this.cartao.bandeira || this.obtenhaBandeiraPeloNumero();
    this.cartao.ultimosNumeros = this.somenteNumeros(this.cartao.numero).slice(-4);
    this.cartao.deviceInfo = this.cartao.deviceInfo || this.obtenhaDeviceInfo();
  }

  private async prepareAntifraudeGetnet(): Promise<void> {
    this.cartao.deviceInfo = this.cartao.deviceInfo || this.obtenhaDeviceInfo();

    await this.carregueScriptAntifraudeGetnet(this.cartao.deviceInfo.sessionId)
      .catch((erro) => console.warn('Falha ao carregar antifraude Getnet', erro));
  }

  private carregueScriptAntifraudeGetnet(sessionId: string): Promise<void> {
    if(!sessionId)
      return Promise.resolve();

    const src = `${this.obtenhaBaseAntifraudeGetnet()}/dpm/digital-platform/antifraud/afdf.js?session=${encodeURIComponent(sessionId)}&country=BR`;
    const existente = document.querySelector(`script[data-getnet-antifraud-session="${sessionId}"]`);
    if(existente)
      return Promise.resolve();

    return new Promise<void>((resolve) => {
      const script = document.createElement('script');
      let finalizado = false;
      const finalize = () => {
        if(finalizado) return;
        finalizado = true;
        resolve();
      };

      script.type = 'text/javascript';
      script.async = true;
      script.src = src;
      script.setAttribute('data-getnet-antifraud-session', sessionId);
      script.onload = finalize;
      script.onerror = finalize;

      document.body.appendChild(script);
      window.setTimeout(finalize, 5000);
    });
  }

  private obtenhaBaseAntifraudeGetnet(): string {
    return environment.production ?
      'https://api.globalgetnet.com' :
      'https://api.pre.globalgetnet.com';
  }

  private async autentique3ds(enderecoCobranca: any): Promise<any> {
    this.inicieCarregamento('Preparando autenticacao do banco');
    let autenticacao: any = await this.inicieAutenticacao3ds(enderecoCobranca);

    if(this.status3dsAutenticado(autenticacao))
      return autenticacao;

    if(this.deveExecutarMetodo3ds(autenticacao)){
      await this.executeMetodo3ds(autenticacao);
      this.inicieCarregamento('Continuando autenticacao do banco');
      autenticacao = await this.continueAutenticacao3ds(autenticacao);
    }

    if(this.status3dsAutenticado(autenticacao))
      return autenticacao;

    if(this.deveExecutarDesafio3ds(autenticacao)){
      this.finalizeCarregamento();
      const token = await this.executeChallenge3ds(autenticacao);
      this.inicieCarregamento('Validando autenticacao do banco');
      return await this.valideAutenticacao3ds(autenticacao, token);
    }

    if(this.permitePagamentoSem3ds(autenticacao))
      return autenticacao;

    throw Error(`Autenticação 3DS Getnet não concluída: ${autenticacao?.status || 'status não retornado'}`);
  }

  private async inicieAutenticacao3ds(enderecoCobranca: any): Promise<any> {
    const payload = Object.assign(this.montePayload3dsBase(enderecoCobranca), {
      term_url: `${window.location.origin}/getnet/3ds/retorno`
    });

    const resposta: any = await this.http.post('/getnet/3ds/enrolments-initial', payload).toPromise();
    return this.extraiaDataResposta(resposta);
  }

  private async continueAutenticacao3ds(autenticacao: any): Promise<any> {
    const resposta: any = await this.http.post('/getnet/3ds/enrolments-continue', {
      formaDePagamentoId: this.formaDePagamento?.id,
      transaction_id: autenticacao.transaction_id,
      xid: autenticacao.xid,
      md: autenticacao.md,
      tx_id: autenticacao.tx_id
    }).toPromise();

    return this.extraiaDataResposta(resposta);
  }

  private async valideAutenticacao3ds(autenticacao: any, token: string): Promise<any> {
    const resposta: any = await this.http.post('/getnet/3ds/validations', {
      formaDePagamentoId: this.formaDePagamento?.id,
      transaction_id: autenticacao.transaction_id,
      xid: autenticacao.xid,
      token
    }).toPromise();

    return this.extraiaDataResposta(resposta);
  }

  private montePayload3dsBase(enderecoCobranca: any): any {
    return {
      formaDePagamentoId: this.formaDePagamento?.id,
      amount: this.valorPedidoEmCentavos(),
      currency: 'BRL',
      token: this.cartao.token,
      expiration_month: this.obtenhaMesValidade(),
      expiration_year: this.obtenhaAnoValidade(),
      security_code: this.cartao.cvv,
      billing_address: enderecoCobranca,
      extra_fields: this.monteExtraFields3ds(enderecoCobranca)
    };
  }

  private monteExtraFields3ds(enderecoCobranca: any): any {
    const billingAddress = this.monteEnderecoExtraFields3ds(enderecoCobranca);
    const shippingAddress = this.monteEnderecoExtraFields3ds(this.obtenhaEnderecoEntrega3ds()) || billingAddress;

    return this.removaVazios({
      billing_address: billingAddress,
      shipping_address: shippingAddress
    });
  }

  private obtenhaEnderecoEntrega3ds(): any {
    if(this.pedido?.entrega?.ehDelivery?.())
      return this.pedido.entrega.endereco;

    return (this.pedido as any)?.endereco;
  }

  private monteEnderecoExtraFields3ds(endereco: any): any {
    if(!endereco?.logradouro)
      return null;

    const cidade = endereco?.cidade?.nome || endereco?.nomeCidade || endereco?.localidade;
    const estado = endereco?.cidade?.estado?.sigla || endereco?.estado?.sigla ||
      endereco?.cidade?.estado?.uf || endereco?.estado?.uf || endereco?.uf;

    return this.removaVazios({
      street: endereco.logradouro,
      number: String(endereco.numero || '0'),
      complement: endereco.complemento,
      district: endereco.bairro,
      city: cidade,
      state: estado,
      country: 'BR',
      postal_code: this.somenteNumeros(endereco.cep),
      reference: endereco.pontoDeReferencia || endereco.referencia || endereco.reference
    });
  }

  private removaVazios(obj: any): any {
    if(Array.isArray(obj))
      return obj.map((item) => this.removaVazios(item));

    if(!obj || typeof obj !== 'object')
      return obj;

    Object.keys(obj).forEach((chave) => {
      obj[chave] = this.removaVazios(obj[chave]);
      if(obj[chave] === null || obj[chave] === undefined || obj[chave] === '')
        delete obj[chave];
    });

    return obj;
  }

  private executeMetodo3ds(autenticacao: any): Promise<void> {
    if(!autenticacao?.tds_method_content)
      return Promise.resolve();

    return new Promise<void>((resolve) => {
      const container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.left = '-9999px';
      container.style.top = '-9999px';
      container.style.width = '1px';
      container.style.height = '1px';
      container.style.overflow = 'hidden';

      const iframe = document.createElement('iframe');
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.border = '0';
      iframe.style.visibility = 'hidden';
      iframe.setAttribute('sandbox', 'allow-forms allow-scripts allow-same-origin');
      iframe.srcdoc = `<!DOCTYPE html><html><body>${autenticacao.tds_method_content}</body></html>`;

      const limpar = () => {
        container.remove();
        resolve();
      };

      container.appendChild(iframe);
      document.body.appendChild(container);
      window.setTimeout(limpar, 10000);
    });
  }

  private executeChallenge3ds(autenticacao: any): Promise<string> {
    const html = this.monteHtmlChallenge3ds(autenticacao);
    if(!html)
      throw Error('Getnet solicitou desafio 3DS, mas não retornou HTML de autenticação');

    return new Promise<string>((resolve, reject) => {
      this.resolveDesafio3ds = resolve;
      this.rejectDesafio3ds = reject;
      this.desafio3dsAberto = true;
      this.desafio3dsCarregando = true;
      this.changeDetector.detectChanges();

      const iframe = this.monteIframeDesafio3ds(html);
      const limpar = () => this.limpeDesafio3ds(receberMensagem);

      this.timeoutDesafio3ds = window.setTimeout(() => {
        limpar();
        reject('Tempo esgotado na autenticação 3DS Getnet');
      }, 180000);

      const receberMensagem = (event: MessageEvent) => {
        const data: any = event.data;
        if(!data || data.origem !== 'promokit-getnet-3ds')
          return;

        window.clearTimeout(this.timeoutDesafio3ds);
        limpar();

        if(data.status === 'success' && data.token)
          resolve(data.token);
        else
          reject('Autenticação 3DS Getnet não retornou token de validação');
      };

      this.listenerDesafio3ds = receberMensagem;
      window.addEventListener('message', receberMensagem, false);
      this.containerDesafio3ds.nativeElement.innerHTML = '';
      this.containerDesafio3ds.nativeElement.appendChild(iframe);
    });
  }

  cancelarDesafio3ds(){
    const rejeitar = this.rejectDesafio3ds;
    this.limpeDesafio3ds();

    if(rejeitar)
      rejeitar('Autenticação 3DS Getnet cancelada');
  }

  private monteIframeDesafio3ds(html: string): HTMLIFrameElement {
    const iframe = document.createElement('iframe');
    iframe.className = 'frame-desafio-3ds';
    iframe.setAttribute('title', 'Autenticação do banco');
    iframe.setAttribute('sandbox', 'allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation');
    iframe.onload = () => {
      this.desafio3dsCarregando = false;
      this.changeDetector.detectChanges();
    };
    iframe.srcdoc = html;

    return iframe;
  }

  private limpeDesafio3ds(listener: any = null) {
    const listenerParaRemover = listener || this.listenerDesafio3ds;
    if(listenerParaRemover)
      window.removeEventListener('message', listenerParaRemover);

    if(this.timeoutDesafio3ds)
      window.clearTimeout(this.timeoutDesafio3ds);

    this.timeoutDesafio3ds = null;
    this.listenerDesafio3ds = null;
    this.resolveDesafio3ds = null;
    this.rejectDesafio3ds = null;
    this.desafio3dsAberto = false;
    this.desafio3dsCarregando = false;

    if(this.containerDesafio3ds)
      this.containerDesafio3ds.nativeElement.innerHTML = '';

    this.changeDetector.detectChanges();
  }

  private monteHtmlChallenge3ds(autenticacao: any): string {
    if(autenticacao.redirect_html_template)
      return autenticacao.redirect_html_template;

    if(autenticacao.acs_redirect_form?.html)
      return autenticacao.acs_redirect_form.html;

    const form = autenticacao.acs_redirect_form;
    if(!form?.action_url)
      return null;

    const campos = {
      creq: form.creq,
      threeDSSessionData: form.threeDSSessionData || form.three_ds_session_data
    };
    const inputs = Object.keys(campos)
      .filter((chave) => campos[chave])
      .map((chave) => `<input type="hidden" name="${this.escapeHtml(chave)}" value="${this.escapeHtml(campos[chave])}">`)
      .join('');

    return `<!DOCTYPE html><html><body>
<form id="frmGetnet3ds" method="POST" action="${this.escapeHtml(form.action_url)}">${inputs}</form>
<script>document.getElementById('frmGetnet3ds').submit();</script>
</body></html>`;
  }

  private escapeHtml(valor: any): string {
    return String(valor || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  private normalizeAutenticacao3ds(autenticacao: any): any {
    if(!this.status3dsAutenticado(autenticacao))
      throw Error(`Autenticação 3DS Getnet inválida: ${autenticacao?.status || 'status não retornado'}`);

    return {
      transaction_id: autenticacao.transaction_id,
      xid: autenticacao.xid,
      eci: autenticacao.eci,
      cavv: autenticacao.cavv,
      ds_trans_id: autenticacao.ds_trans_id,
      status: autenticacao.status,
      protocol: autenticacao.protocol
    };
  }

  private apliqueRetornoAutenticacao3ds(autenticacao: any): void {
    if(this.possuiDadosAutenticacao3ds(autenticacao)){
      this.cartao.autenticacao3ds = this.normalizeAutenticacao3ds(autenticacao);
      delete (this.cartao as any).autenticacao3dsNaoSuportada;
      delete (this.cartao as any).autenticacao3dsStatus;
      delete (this.cartao as any).autenticacao3dsMotivo;
      return;
    }

    if(this.permitePagamentoSem3ds(autenticacao)){
      delete this.cartao.autenticacao3ds;
      (this.cartao as any).autenticacao3dsNaoSuportada = true;
      (this.cartao as any).autenticacao3dsStatus = autenticacao?.status || null;
      (this.cartao as any).autenticacao3dsMotivo = this.obtenhaTextoAutenticacao3ds(autenticacao);
      return;
    }

    this.cartao.autenticacao3ds = this.normalizeAutenticacao3ds(autenticacao);
  }

  private status3dsAutenticado(autenticacao: any): boolean {
    const status = this.normalizeStatus3ds(autenticacao);
    return status === 'authenticated' || status === 'attempt';
  }

  private possuiDadosAutenticacao3ds(autenticacao: any): boolean {
    return this.status3dsAutenticado(autenticacao) &&
      Boolean(autenticacao?.xid && autenticacao?.eci && autenticacao?.ds_trans_id);
  }

  private status3dsChallenge(autenticacao: any): boolean {
    return this.normalizeStatus3ds(autenticacao) === 'pending challenge';
  }

  private status3dsEnrollmentContinue(autenticacao: any): boolean {
    return this.normalizeStatus3ds(autenticacao) === 'pending enrollment continue';
  }

  private deveExecutarMetodo3ds(autenticacao: any): boolean {
    return Boolean(autenticacao?.tds_method_content) || this.status3dsEnrollmentContinue(autenticacao);
  }

  private deveExecutarDesafio3ds(autenticacao: any): boolean {
    return this.status3dsChallenge(autenticacao) ||
      Boolean(autenticacao?.redirect_html_template || autenticacao?.acs_redirect_form?.html || autenticacao?.acs_redirect_form?.action_url);
  }

  private normalizeStatus3ds(autenticacao: any): string {
    return String(autenticacao?.status || '').toLowerCase().replace('enrolment', 'enrollment');
  }

  private permitePagamentoSem3ds(autenticacao: any): boolean {
    const texto = this.obtenhaTextoAutenticacao3ds(autenticacao);
    const status = this.normalizeStatus3ds(autenticacao);

    if(texto.indexOf('not authenticated') >= 0 || texto.indexOf('do not continue transaction') >= 0)
      return false;

    if(['failed', 'failure', 'rejected', 'denied', 'declined', 'error'].indexOf(status) >= 0)
      return false;

    if(autenticacao?.fallback_sem_3ds === true){
      this.validePagamentoSem3dsPermitido();
      return true;
    }

    const permite = [
      'not enrolled',
      'not supported',
      'unsupported',
      'unavailable',
      'unable to authenticate',
      'u-received',
      'grey area',
      'cardholder not enrolled',
      'issuer not participating',
      'attempt'
    ].some((indicador) => texto.indexOf(indicador) >= 0 || status === indicador);

    if(permite)
      this.validePagamentoSem3dsPermitido();

    return permite;
  }

  private validePagamentoSem3dsPermitido(): void {
    if(this.ehCartaoDebito() || this.ehRetiradaOuSemEnderecoEntrega())
      throw Error('Autenticação 3DS obrigatória para cartão de débito ou retirada');
  }

  private ehCartaoDebito(): boolean {
    const tipo = String(this.cartao?.tipoDoCartao?.id || this.cartao?.tipoDoCartao || '').toUpperCase();
    return tipo === 'DEBIT' || tipo === 'DEBIT_CARD';
  }

  private ehRetiradaOuSemEnderecoEntrega(): boolean {
    if((this.pedido as any)?.retirar || this.pedido?.entrega?.ehRetirada?.())
      return true;

    if(this.pedido?.entrega?.ehDelivery?.())
      return !this.pedido.entrega.endereco;

    return !(this.pedido as any)?.endereco;
  }

  private obtenhaTextoAutenticacao3ds(autenticacao: any): string {
    return [
      autenticacao?.status,
      autenticacao?.reason,
      autenticacao?.reason_code,
      autenticacao?.reason_message,
      autenticacao?.message,
      autenticacao?.description,
      autenticacao?.description_detail,
      autenticacao?.error,
      autenticacao?.error_description,
      autenticacao?.fallback_sem_3ds ? 'fallback_sem_3ds' : null
    ].filter((valor) => valor).join(' ').toLowerCase().replace('enrolment', 'enrollment');
  }

  private inicieCarregamento(mensagem: string) {
    this.mensagemCarregamento = mensagem;
    this.carregando = true;
  }

  private finalizeCarregamento() {
    this.carregando = false;
    this.mensagemCarregamento = 'Validando cartao com seguranca';
  }

  private extraiaDataResposta(resposta: any): any {
    if(resposta && resposta.sucesso === false)
      throw Error(resposta.erro || 'Falha Getnet');

    if(resposta && resposta.sucesso === true)
      return resposta.data;

    return resposta;
  }

  private obtenhaMesValidade(): string {
    if(!this.cartao.validade) return null;

    return String(new Date(this.cartao.validade).getMonth() + 1).padStart(2, '0');
  }

  private obtenhaAnoValidade(): string {
    if(!this.cartao.validade) return null;

    return String(new Date(this.cartao.validade).getFullYear()).slice(-2);
  }

  private valorPedidoEmCentavos(): number {
    const pedido: any = this.pedido as any;
    const total = pedido?.obtenhaValorAhPagar ? pedido.obtenhaValorAhPagar() :
      (pedido?.totalPagar || pedido?.total || 0);

    return Math.round(Number(total || 0) * 100);
  }

  private obtenhaDeviceInfo(): any {
    const deviceId = this.obtenhaDeviceId();
    return {
      deviceId,
      sessionId: deviceId,
      fingerPrint: this.obtenhaFingerPrint(deviceId),
      userAgent: navigator.userAgent,
      language: navigator.language,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      colorDepth: window.screen.colorDepth,
      timeZoneOffset: new Date().getTimezoneOffset()
    };
  }

  private obtenhaDeviceId(): string {
    const cryptoObj = window.crypto || (window as any).msCrypto;

    if(cryptoObj?.randomUUID)
      return cryptoObj.randomUUID();

    if(cryptoObj?.getRandomValues){
      const bytes = new Uint8Array(16);
      cryptoObj.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const hex = Array.from(bytes).map((byte) => byte.toString(16).padStart(2, '0')).join('');
      return `${hex.substring(0, 8)}-${hex.substring(8, 12)}-${hex.substring(12, 16)}-${hex.substring(16, 20)}-${hex.substring(20)}`;
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (caractere) => {
      const aleatorio = Math.random() * 16 | 0;
      const valor = caractere === 'x' ? aleatorio : (aleatorio & 0x3 | 0x8);
      return valor.toString(16);
    });
  }

  private obtenhaFingerPrint(deviceId: string): string {
    const dados = [
      deviceId,
      navigator.userAgent,
      navigator.language,
      window.screen.height,
      window.screen.width,
      window.screen.colorDepth,
      new Date().getTimezoneOffset()
    ].join('|');

    try{
      return btoa(unescape(encodeURIComponent(dados))).substring(0, 250);
    } catch(e) {
      return deviceId;
    }
  }

  private obtenhaBandeiraPeloNumero(): string {
    const numero = this.somenteNumeros(this.cartao.numero);

    if(/^4/.test(numero)) return 'Visa';
    if(/^5[1-5]/.test(numero) || /^2[2-7]/.test(numero)) return 'Mastercard';
    if(/^3[47]/.test(numero)) return 'Amex';
    if(/^38|^60/.test(numero)) return 'Hipercard';
    if(/^4011|^4312|^4389|^4514|^4576|^5041|^5067|^509|^6277|^6362|^6363|^650|^6516|^6550/.test(numero)) return 'Elo';

    return null;
  }

  private somenteNumeros(valor: any): string {
    return valor ? String(valor).replace(/\D/g, '') : '';
  }

  private obtenhaMensagemErro(erro: any): string {
    if(erro?.error?.erro) return erro.error.erro;
    if(erro?.error?.message) return erro.error.message;
    if(erro?.message) return erro.message;

    return String(erro || 'Falha no Checkout Pro Getnet');
  }
}
